'use strict';

const $ = require('jquery');
require('bootstrap');
require("babel-polyfill");

const App = require('./app');

$(document).ready(function() {
  new App();
});
